import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { List } from "linqts";
import { ApplicationType } from "../../entity/ApplicationType";
import { Technology } from "../../entity/Technology";
import { TechnologyCategory } from "../../entity/TechnologyCategory";
import { HomeCarouselViewModel } from "../components/home/home-carousel/home-carousel.view-model";
import { AbstractCRUDService } from "./AbstractCRUDService";
import { ApplicationTypeService } from "./ApplicationTypeService";
import { TechnologyCategoryService } from "./TechnologyCategoryService";

@Injectable()
export class TechnologyService extends AbstractCRUDService<Technology, number> {

	private readonly applicationTypeService: ApplicationTypeService;
	private readonly technologyCategoryService: TechnologyCategoryService;

	private constructor(httpClient: HttpClient, applicationTypeService: ApplicationTypeService, technologyCategoryService: TechnologyCategoryService) {
		super(httpClient);
		this.applicationTypeService = applicationTypeService;
		this.technologyCategoryService = technologyCategoryService;
	}

	public async getAllAsync(): Promise<Technology[]> {
		return [
			{
				id: 1,
				name: "OLED Button For Textile integration",
				description: "Light emitting OLED button",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(5),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(9),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/oled-lighting/OLED_Button.png",
				carouselImageUrl: undefined,
				index: 1,
				images: [
					"/assets/images/icons/oled-lighting/OLED_Button.png",
					"/assets/images/icons/oled-lighting/OLED_Button_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/1.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(3),
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 2,
				name: "OLED stripes for textile integration",
				description: "Light emitting flexible OLED stripe",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(5),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(9),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/oled-lighting/OLED_stripe.png",
				carouselImageUrl: undefined,
				index: 2,
				images: [
					"/assets/images/icons/oled-lighting/OLED_stripe.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/2.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(3),
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 3,
				name: "Color variable OLED for digital signage",
				description: "Color tunabele OLED signage element",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(5),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/oled-lighting/OLED_variable.png",
				carouselImageUrl: "/assets/images/home-carousel/light.png",
				index: 3,
				images: [
					"/assets/images/icons/oled-lighting/OLED_variable.png",
					"/assets/images/icons/oled-lighting/OLED_variable_2.png",
				],
				showInCarousel: true,
				specification: "/assets/markdown/3.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(3),
				],
			},
			{
				id: 4,
				name: "OLED with customized logo (Name Tag)",
				description: "Name tag by OLED signage",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/oled-lighting/OLED_logo.png",
				carouselImageUrl: undefined,
				index: 4,
				images: [
					"/assets/images/icons/oled-lighting/OLED_logo.png",
					"/assets/images/icons/oled-lighting/OLED_logo_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/4.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(3),
				],
			},
			{
				id: 5,
				name: "Terra - merging biology and design",
				description: "Name tag by OLED signage",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/oled-lighting/OLED_terra.png",
				carouselImageUrl: undefined,
				index: 5,
				images: [
					"/assets/images/icons/oled-lighting/OLED_terra.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/5.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(3),
				],
			},
			{
				id: 6,
				name: "Overmoulded full colour LED matrix  ",
				description: "Customized fully controllable LED matrix display, signage and lighting module. The" +
				" flexible elements can be connected to create large area systems",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(7),
				],
				cardImage: "/assets/images/icons/oled-lighting/OLED_matrix.png",
				carouselImageUrl: undefined,
				index: 6,
				images: [
					"/assets/images/icons/oled-lighting/OLED_matrix.png",
					"/assets/images/icons/oled-lighting/OLED_matrix_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/6.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 7,
				name: "Active matrix backplanes for displays and imagers",
				description: "High-resolution pixel arrays for display and imager applications on glass or plastic",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/flexible-electronics/backplanes.png",
				carouselImageUrl: "/assets/images/home-carousel/interaction.png",
				index: 7,
				images: [
					"/assets/images/icons/flexible-electronics/backplanes.png",
					"/assets/images/icons/flexible-electronics/backplanes_2.png",
					"/assets/images/icons/flexible-electronics/backplanes_3.png",
				],
				showInCarousel: true,
				specification: "/assets/markdown/raw.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
				],
			},
			{
				id: 8,
				name: "TFT in Automotive",
				description: "Automotive displays and HMI. In-MOULD electronics with integration of OLED, LED and/or " +
				"photodetectors",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
				],
				cardImage: "/assets/images/icons/flexible-electronics/TFT_Automotive.png",
				carouselImageUrl: undefined,
				index: 8,
				images: [
					"/assets/images/icons/flexible-electronics/TFT_Automotive.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/raw.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
				],
			},
			{
				id: 9,
				name: "TFT in Medical Imaging",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/flexible-electronics/TFT_Medical.png",
				carouselImageUrl: undefined,
				index: 9,
				images: [
					"/assets/images/icons/flexible-electronics/TFT_Medical.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/9.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
				],
			},
			{
				id: 10,
				name: "Disposable rapid diagnostics",
				description: "Personal health solutions for home use",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(7),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/rapid-diagnostics.png",
				carouselImageUrl: undefined,
				index: 10,
				images: [
					"/assets/images/icons/integrated-smart-systems/rapid-diagnostics.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/10.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 11,
				name: "Indoor air quality sensing luminaire",
				description: "Ambient environment sensing in home, office or school class.",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/indoor-air-quality.png",
				carouselImageUrl: undefined,
				index: 11,
				images: [
					"/assets/images/icons/integrated-smart-systems/indoor-air-quality.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/11.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 12,
				name: "Elastomer integrated Bluetooth sensor node",
				description: "Wireless overmolded sensor for buildings, wearable, environmental applications",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/elastomer.png",
				carouselImageUrl: undefined,
				index: 12,
				images: [
					"/assets/images/icons/integrated-smart-systems/elastomer.png",
					"/assets/images/icons/integrated-smart-systems/elastomer_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/12.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 13,
				name: "OLED glasses for health applications ",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(7),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/OLED_glasses.png",
				carouselImageUrl: undefined,
				index: 13,
				images: [
					"/assets/images/icons/integrated-smart-systems/OLED_glasses.png",
					"/assets/images/icons/integrated-smart-systems/OLED_glasses_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/13.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(3),
				],
			},
			{
				id: 14,
				name: "ECG Patch",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/ECG_patch.png",
				carouselImageUrl: undefined,
				index: 14,
				images: [
					"/assets/images/icons/integrated-smart-systems/ECG_patch.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/14.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 15,
				name: "Smart Blister",
				description: "Thin foil smart blister to create intelligent tablet packaging that actively helps people control its daily medication. Smart blister printed electronics technology for high-volume pharmaceutical applications.Thin foil smart blister to create intelligent tablet packaging that actively helps people control its daily medication. Smart blister printed electronics technology for high-volume pharmaceutical applications.",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/Smart-Blister.png",
				carouselImageUrl: undefined,
				index: 15,
				images: [
					"/assets/images/icons/integrated-smart-systems/Smart-Blister.png",
					"/assets/images/icons/integrated-smart-systems/Smart-Blister_2.png",
					"/assets/images/icons/integrated-smart-systems/Smart-Blister_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/15.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 16,
				name: "Electroluminescence",
				description: "Printed flexible light that convert inert surfaces into smart lighting objects. Industrial fabrics, home textiles, wearables, technical films or even glass can be supplied with additional lighting functionality integrated in an ergonomic way.",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(5),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
					await this.applicationTypeService.getByIdAsync(10),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/electroluminescence.png",
				carouselImageUrl: "/assets/images/home-carousel/intelligence.png",
				index: 16,
				images: [
					"/assets/images/icons/integrated-smart-systems/electroluminescence.png",
					"/assets/images/icons/integrated-smart-systems/electroluminescence_2.png",
					"/assets/images/icons/integrated-smart-systems/electroluminescence_3.png",
				],
				showInCarousel: true,
				specification: "/assets/markdown/16.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 17,
				name: "Wereables",
				description: "Soft-electronics. Design and integration of technology into textile fabrics for interactive and functional properties for applications within health, sport and \"fashion\". Conceptual design for prototyping solutions and functional fabrics through smart textiles, ergonomics and aesthetics. \n",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(10),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/integrated-smart-systems/Wereables.png",
				carouselImageUrl: undefined,
				index: 17,
				images: [
					"/assets/images/icons/integrated-smart-systems/Wereables.png",
					"/assets/images/icons/integrated-smart-systems/Wereables_2.png",
					"/assets/images/icons/integrated-smart-systems/Wereables_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/17.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 18,
				name: "BioFuelCell - Iontophoretics for cosmetics applications",
				description: "Health patches for cosmetics by utilizing iontophoretic methods.\n",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(7),
				],
				cardImage: "/assets/images/icons/eComponents/biofuelcell.png",
				carouselImageUrl: "/assets/images/home-carousel/control.png",
				index: 18,
				images: [
					"/assets/images/icons/eComponents/biofuelcell.png",
					"/assets/images/icons/eComponents/biofuelcell_2.png",
				],
				showInCarousel: true,
				specification: "/assets/markdown/18.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 19,
				name: "Near Field Communication (NFC) for Wireless Data and Charging.",
				description: "Customized NFC powered NFC Tag for sensoring and data collection applications",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(7),
				],
				cardImage: "/assets/images/icons/eComponents/NFC_data.png",
				carouselImageUrl: undefined,
				index: 19,
				images: [
					"/assets/images/icons/eComponents/NFC_data.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/19.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 20,
				name: "Design your own printed logic circuit",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(5),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/eComponents/circuit.png",
				carouselImageUrl: undefined,
				index: 20,
				images: [
					"/assets/images/icons/eComponents/circuit.png",
					"/assets/images/icons/eComponents/circuit-2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/20.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 21,
				name: "Touch sensor",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/eComponents/touch-sensor.png",
				carouselImageUrl: undefined,
				index: 21,
				images: [
					"/assets/images/icons/eComponents/touch-sensor.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/21.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 22,
				name: "Pressure sensor",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/eComponents/pressure-sensor.png",
				carouselImageUrl: undefined,
				index: 22,
				images: [
					"/assets/images/icons/eComponents/pressure-sensor.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/22.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 23,
				name: "Antenae",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/eComponents/antenae.png",
				carouselImageUrl: undefined,
				index: 23,
				images: [
					"/assets/images/icons/eComponents/antenae.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/23.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 24,
				name: "Printed Speaker/Actuators",
				description: "Printed and pakaged speakers",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/eComponents/speaker.png",
				carouselImageUrl: undefined,
				index: 24,
				images: [
					"/assets/images/icons/eComponents/speaker.png",
					"/assets/images/icons/eComponents/speaker_2.png",
					"/assets/images/icons/eComponents/speaker_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/24.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 25,
				name: "Printed Sensor Array for Helmets",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(10),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/eComponents/helmet.png",
				carouselImageUrl: undefined,
				index: 25,
				images: [
					"/assets/images/icons/eComponents/helmet.png",
					"/assets/images/icons/eComponents/helmet_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/25.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 26,
				name: "REMEDIES Smart Labels",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
				],
				cardImage: "/assets/images/icons/eComponents/smart-label.png",
				carouselImageUrl: undefined,
				index: 26,
				images: [
					"/assets/images/icons/eComponents/smart-label.png",
					"/assets/images/icons/eComponents/smart-label_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/26.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 27,
				name: "OPD for brightness control ",
				description: "",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(5),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/icons/eComponents/opd.png",
				carouselImageUrl: undefined,
				index: 27,
				images: [
					"/assets/images/icons/eComponents/opd.png",
					"/assets/images/icons/eComponents/opd_2.png",
					"/assets/images/icons/eComponents/opd_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/27.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 28,
				name: "Thin-film RFID and sensors for smart packaging",
				description: "Thin-film RFID and sensors integrated circuits and (printed) sensors fo smart tracking" +
				" and packaging",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
				],
				cardImage: "/assets/images/icons/eComponents/tft-packaging.png",
				carouselImageUrl: undefined,
				index: 28,
				images: [
					"/assets/images/icons/eComponents/tft-packaging.png",
					"/assets/images/icons/eComponents/packaging.png",
					"/assets/images/icons/eComponents/packaging_2np.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/28.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 29,
				name: "Hybrid printed electronics",
				description: "Combinatiopn of printed and placed electric components for Smart packaging, Building, " +
				"Automotive and medical",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
				],
				cardImage: "/assets/images/icons/eComponents/hybrid.png",
				carouselImageUrl: undefined,
				index: 29,
				images: [
					"/assets/images/icons/eComponents/hybrid.png",
					"/assets/images/icons/eComponents/hybrid_2.png",
					"/assets/images/icons/eComponents/hybrid_3.png",
					"/assets/images/icons/eComponents/hybrid_4.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/raw.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 30,
				name: "Wearable/ Stretchable electronics",
				description: "Stretchable electronics are used for conforming to the body (patches, clothing)",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
				],
				cardImage: "/assets/images/icons/eComponents/wereable_2.png",
				carouselImageUrl: undefined,
				index: 30,
				images: [
					"/assets/images/icons/eComponents/wereable_2.png",
					"http://via.placeholder.com/75x75",
					"http://via.placeholder.com/75x75",
				],
				showInCarousel: false,
				specification: "/assets/markdown/raw.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 31,
				name: "Fitness Shirt",
				description: "",
				applicationTypes: [
				],
				cardImage: "/assets/images/icons/eComponents/shirt.png",
				carouselImageUrl: undefined,
				index: 31,
				images: [
					"/assets/images/icons/eComponents/shirt.png",
					"/assets/images/icons/eComponents/shirt_2.png",
					"/assets/images/icons/eComponents/shirt_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/31.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 32,
				name: "In Mold Electronics",
				description: "Functional plastic pieces combining printed electronics",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/icons/eComponents/mold_electronics.png",
				carouselImageUrl: undefined,
				index: 32,
				images: [
					"/assets/images/icons/eComponents/mold_electronics.png",
					"/assets/images/icons/eComponents/mold_electronics_2.png",
					"/assets/images/icons/eComponents/mold_electronics_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/33.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 33,
				name: "Flexible Solar modules",
				description: "Plastic solar cells are based on semiconducting organic polymers that interact with visible light to produce electricity. The application of polymers result in flexible elements that offer new integration capabilities not achievable by silicon-based solar cells. In addition, the plastic modules are thin, lightweight and easy to integrate.",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(4),
				],
				cardImage: "/assets/images/icons/photovoltaics/photovoltaics.png",
				carouselImageUrl: "/assets/images/home-carousel/energy.png",
				index: 33,
				images: [
					"/assets/images/icons/photovoltaics/photovoltaics.png",
					"/assets/images/icons/photovoltaics/photovoltaics_2.png",
					"/assets/images/icons/photovoltaics/photovoltaics_3.png",
					"/assets/images/icons/photovoltaics/photovoltaics_4.png",
					"/assets/images/icons/photovoltaics/photovoltaics_5.png",
				],
				showInCarousel: true,
				specification: "/assets/markdown/raw.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(1),
				],
			},
			{
				id: 34,
				name: "Organic Solar Cells - Photovoltaic for interior design",
				description: "Customized organic solar cells modules for indoor and outdoor energy harvesting." +
				" Design freedom of A4 size elements or continous 300mm wide solar foil.",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
				],
				cardImage: "/assets/images/icons/photovoltaics/SolarCells.png",
				carouselImageUrl: undefined,
				index: 34,
				images: [
					"/assets/images/icons/photovoltaics/SolarCells.png",
					"/assets/images/icons/photovoltaics/SolarCells_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/35.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(1),
				],
			},
			{
				id: 35,
				name: "Flexible OPV module",
				description: "OPV flexible module with specific integration for outdoor, indoor applications",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/photovoltaics/OPV.png",
				carouselImageUrl: undefined,
				index: 35,
				images: [
					"/assets/images/icons/photovoltaics/OPV.png",
					"/assets/images/icons/photovoltaics/OPV_1.png",
					"/assets/images/icons/photovoltaics/OPV_2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/36.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(1),
				],
			},
			{
				id: 36,
				name: "OPV for interior design",
				description: "Autonomous switch or captor for indoor/outdoor application with design on-demand",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(8),
				],
				cardImage: "/assets/images/icons/photovoltaics/OPV_3.png",
				carouselImageUrl: undefined,
				index: 36,
				images: [
					"/assets/images/icons/photovoltaics/OPV_3.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/34.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(1),
				],
			},
			{
				id: 37,
				name: "Flexible Sensitive Surface",
				description: "Quantification and localization of several pressure points",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(1),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/technology/technology-37.jpg",
				carouselImageUrl: undefined,
				index: 37,
				images: [
					"/assets/images/technology/technology-37.jpg",
				],
				showInCarousel: false,
				specification: "/assets/markdown/37.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
				],
			},
			{
				id: 38,
				name: "Flexible multi-sensing platform",
				description: "Low power multi-sensing platform for IoT applications",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(10),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/technology/technology-38-1.png",
				carouselImageUrl: undefined,
				index: 38,
				images: [
					"/assets/images/technology/technology-38-1.png",
					"/assets/images/technology/technology-38-2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/38.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},
			{
				id: 39,
				name: "3D deformation or movement mapping",
				description: "SnapShape3D - Dynamically map the 3D deformation of large surfaces",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(2),
					await this.applicationTypeService.getByIdAsync(3),
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(6),
					await this.applicationTypeService.getByIdAsync(8),
					await this.applicationTypeService.getByIdAsync(9),
					await this.applicationTypeService.getByIdAsync(11),
				],
				cardImage: "/assets/images/technology/technology-39-1.png",
				carouselImageUrl: undefined,
				index: 39,
				images: [
					"/assets/images/technology/technology-39-1.png",
					"/assets/images/technology/technology-39-2.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/39.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(2),
				],
			},
			{
				id: 40,
				name: "Solid State Microbatteries – Embedded energy storage solution",
				description: "Customized solid state microbatteries for flexible electronics and miniaturized smart systems. Free Form Factor Designs",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(4),
					await this.applicationTypeService.getByIdAsync(3),
				],
				cardImage: "/assets/images/technology/technology-40-2.jpg",
				carouselImageUrl: undefined,
				index: 40,
				images: [
					"/assets/images/technology/technology-40-1.jpg",
					"/assets/images/technology/technology-40-2.jpg",
				],
				showInCarousel: false,
				specification: "/assets/markdown/40.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(1),
				],
			},

			{
				id: 41,
				name: "Project ORIGAMO - OveRnIGht Asthma Monitoring",
				description: "Project ORIGAMO - OveRnIGht Asthma Monitoring proposed by ItoM Medical B.V., and being developed by Centre for Process Innovation and Blumorpho, is the development of a wearable medical monitoring device. The medical device addresses the problem of uncontrolled asthma in children. This is a huge and growing problem worldwide. These children may fail to respond promptly when adverse effects occur, which often leads to asthma attacks or even emergency hospital visits. Children with uncontrolled asthma suffer from a decreased quality of life. Overall healthcare costs of uncontrolled asthma are high.",
				applicationTypes: [
					await this.applicationTypeService.getByIdAsync(7),
					await this.applicationTypeService.getByIdAsync(10),
				],
				cardImage: "/assets/images/technology/technology-41-1.png",
				carouselImageUrl: undefined,
				index: 41,
				images: [
					"/assets/images/technology/technology-41-1.png",
				],
				showInCarousel: false,
				specification: "/assets/markdown/41.md",
				technologyCategories: [
					await this.technologyCategoryService.getByIdAsync(4),
				],
			},

		].sort((a: Technology, b: Technology): number =>
			b.applicationTypes.length - a.applicationTypes.length);
	}

	public async getAllByTechnologyCategoryAsync(technologyCategory: TechnologyCategory): Promise<Technology[]> {
		return (await this.getAllAsync()).filter((value: Technology) => {
			value.technologyCategories = value.technologyCategories.filter((value2: TechnologyCategory) =>
				value2.id === technologyCategory.id);
			return value.technologyCategories.length > 0;
		});
	}

	public async getAllByApplicationTypeAsync(applicationType: ApplicationType): Promise<Technology[]> {
		return (await this.getAllAsync()).filter((value: Technology) => {
			value.applicationTypes = value.applicationTypes.filter((value2: ApplicationType) =>
				value2.id === applicationType.id);
			return value.applicationTypes.length > 0;
		});
	}

	public async getByIdAsync(id: number): Promise<Technology> {
		const request: Technology[] = await this.getAllAsync();
		for (const technology of request) {
			if (technology.id === id) {
				return technology;
			}
		}
		throw Error("Technology.Id not found");
	}

	public async getByTechnologyCategoryApplicationTypeIdsArray(technologyCategory: TechnologyCategory, applicationTypeIds: number[]): Promise<Technology[]> {
		const request: Technology[] = await this.getAllByTechnologyCategoryAsync(technologyCategory);
		return new List(request).Where((value: Technology) => {
			for (const i of value.applicationTypes) {
				for (const int of applicationTypeIds) {
					if (i.id === int) { return true; }
				}
			}
			return false;
		}).ToArray().sort((a: Technology, b: Technology) => b.applicationTypes.length - a.applicationTypes.length);
	}

	public async getByApplicationTypeTechnologyCategoryIdsArray(applicationType: ApplicationType, technologyCategoryIds: number[]): Promise<Technology[]> {
		const request: Technology[] = await this.getAllByApplicationTypeAsync(applicationType);
		return new List(request).Where((value: Technology) => {
			for (const i of value.technologyCategories) {
				for (const int of technologyCategoryIds) {
					if (i.id === int) { return true; }
				}
			}
			return false;
		}).ToArray().sort((a: Technology, b: Technology) => b.technologyCategories.length - a.technologyCategories.length);
	}

	public async getHomeCarouselComponentAsync(): Promise<HomeCarouselViewModel[]> {
		let result: Technology[] = await this.getAllAsync();
		result = result.filter((value: Technology): boolean => value.showInCarousel && value.carouselImageUrl !== undefined);
		return result.map((technology: Technology): HomeCarouselViewModel =>
			({
				carouselImageUrl: technology.carouselImageUrl,
				technologyCategoryId: technology.technologyCategories[0].id,
			}));
	}

	public async getTechnologyComponentAsync(id: number): Promise<Technology> {
		return this.getByIdAsync(id);
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/services/TechnologyService.ts